import React, { useEffect, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { useNavigate, useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getSubject,
  updateSubject,
} from "../../store/slices/subject";
import { toast } from "react-hot-toast";
import {
  FiHome,
  FiChevronRight,
} from "react-icons/fi";

export default function EditSubject() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const [name, setName] = useState("");
  const [errors, setErrors] = useState({});

  /* ---------- GET SUBJECTS ---------- */

  useEffect(() => {
    dispatch(getSubject());
  }, [dispatch]);

  const { subjectlist = [] } = useSelector(
    (state) => state.subject || {}
  );

  /* ---------- SET SUBJECT DATA ---------- */

  useEffect(() => {
    if (subjectlist.length > 0 && id) {
      const subject = subjectlist.find(
        (item) => item._id === id
      );


      if (subject) {
        setName(subject.name || "");
      }
    }


  }, [subjectlist, id]);

  /* ---------- VALIDATION ---------- */

  const validate = () => {
    const newErrors = {};


    if (!name.trim()) {
      newErrors.name = "Please enter subject name";
    } else if (!/^[A-Za-z\s]+$/.test(name.trim())) {
      newErrors.name =
        "Subject name should contain only letters and spaces";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;


  };

  /* ---------- HANDLE NAME CHANGE ---------- */

  const handleNameChange = (e) => {
    const value = e.target.value;


    // Allow only letters and spaces
    if (/^[A-Za-z\s]*$/.test(value)) {
      setName(value);

      // Remove name error when user types
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors.name;
        return newErrors;
      });
    }


  };

  /* ---------- SUBMIT ---------- */

  const handleSubmit = (e) => {
    e.preventDefault();


    if (!validate()) return;

    dispatch(
      updateSubject({
        id,
        name: name.trim(),
      })
    )
      .unwrap()
      .then(() => {
        toast.success("Subject updated successfully");
        navigate(-1);
      })
      .catch((err) => {
        toast.error(err || "Failed to update subject");
      });


  };

  return (
    <> <div className="page-header"> <div className="breadcrumb-section">


      <div className="breadcrumb-left">

        <div className="home-icon">
          <Link to="/institute/home">
            <FiHome
              style={{
                color: "white",
                marginTop: "-4px",
              }}
            />
          </Link>
        </div>

        <FiChevronRight className="separator" />

        <Link to="/institute/subjects">
          Subjects
        </Link>

        <FiChevronRight className="separator" />

        <span className="active">
          Edit Subject
        </span>

      </div>
    </div>
    </div>

      <div className="acs-card">

        <Form onSubmit={handleSubmit}>

          <Row className="g-3">

            <Col md={3}>
              <Form.Group>

                <Form.Label>
                  Subject Name
                </Form.Label>

                <Form.Control
                  type="text"
                  value={name}
                  maxLength={20}
                  onChange={handleNameChange}
                  placeholder="Enter Subject Name"
                />

                {errors.name && (
                  <small className="text-danger">
                    {errors.name}
                  </small>
                )}

              </Form.Group>
            </Col>

          </Row>

          <div className="sa-actions mt-5">

            <button
              type="button"
              className="btn-cancel"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="btn-submit"
            >
              Update
            </button>

          </div>

        </Form>
      </div>
    </>


  );
}
